import { VideoProviderType } from "@/types/graphql/partner.generated";
import { useCurrentPlatformQuery } from "./useCurrentPlatformQuery";

/**
 * Эффективный видеопровайдер платформы это Bunny. По нему кабинет
 * переключает плитку расхода на дашборде и раздел «Хранилище»: у Bunny
 * тарификация по гигабайтам и без лимита, у Cloudflare по минутам с
 * лимитом. Запрос тот же, что у остальных экранов (Apollo дедуплицирует),
 * поэтому лишнего обращения к бэкенду нет.
 */
export function useIsBunnyProvider(): boolean {
  const { data } = useCurrentPlatformQuery();
  return (
    data?.currentPlatform?.effectiveVideoProvider ===
    VideoProviderType.BunnyType
  );
}
